// There can only be one InfoPopup
export class InfoPopup {
    private static _popup: HTMLElement;
    private static _closePanel: HTMLElement;

    private static _popupCloseEvent: CustomEvent = new CustomEvent(
        "infoPopupClosed",
    );

    private static readonly MAX_SIZE_LANDSCAPE_PX: string = "750px";
    private static readonly MAX_SIZE_PORTRAIT_PX: string = "350px";
    private static readonly FONT_SIZE_LANDSCAPE_REM: string = "3rem";
    private static readonly FONT_SIZE_PORTRAIT_REM: string = "1.25rem";

    public static init() {
        this._popup = document.createElement("div");
        this._closePanel = document.createElement("div");

        this._popup.id = "info-popup";

        const width: number = window.innerWidth;
        const height: number = window.innerHeight;

        const ratio: number = width / height;

        const virtualHeightMax: string =
            ratio < 1 ? this.MAX_SIZE_PORTRAIT_PX : this.MAX_SIZE_LANDSCAPE_PX;

        const virtualHeightPreferred: string = ratio < 1 ? "50vh" : "60vh";

        const virtualFontSizeMax: string =
            ratio < 1 ? this.FONT_SIZE_PORTRAIT_REM : this.FONT_SIZE_LANDSCAPE_REM;
        const virtualFontSizePreferred: string = ratio < 1 ? "2vh" : "3vh";

        Object.assign(this._popup.style, {
            display: "none",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            height: `clamp(100px, ${virtualHeightPreferred}, ${virtualHeightMax})`,
            width: `clamp(100px, ${virtualHeightPreferred}, ${virtualHeightMax})`,
            background: "rgba(0, 0, 0, 0.85)",
            borderRadius: "20px",
            zIndex: "9998",
            fontFamily: "Arial",
            fontWeight: "bold",
            fontSize: `clamp(0.5rem, ${virtualFontSizePreferred}, ${virtualFontSizeMax})`,
        });

        Object.assign(this._closePanel.style, {
            display: "none",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "100%",
            height: "100%",
            zIndex: "9997",
        });

        document.body.appendChild(this._popup);
        document.body.appendChild(this._closePanel);

        this._setupResizeHandler();
        this._setupPopupCloseHandler();
    }

    private static _setupResizeHandler(): void {
        window.addEventListener("resize", () => this._resize());
    }

    private static _setupPopupCloseHandler(): void {
        this._closePanel.addEventListener("click", () => this.hide());
    }

    private static _resize(): void {
        const width: number = window.innerWidth;
        const height: number = window.innerHeight;

        const ratio = width / height;

        const virtualHeightMax: string =
            ratio < 1 ? this.MAX_SIZE_PORTRAIT_PX : this.MAX_SIZE_LANDSCAPE_PX;

        const virtualHeightPreferred: string = ratio < 1 ? "50vh" : "60vh";

        const virtualFontSizeMax: string =
            ratio < 1 ? this.FONT_SIZE_PORTRAIT_REM : this.FONT_SIZE_LANDSCAPE_REM;
        const virtualFontSizePreferred: string = ratio < 1 ? "2vh" : "3vh";

        this._popup.style.height = `clamp(100px, ${virtualHeightPreferred}, ${virtualHeightMax})`;
        this._popup.style.width = `clamp(100px, ${virtualHeightPreferred}, ${virtualHeightMax})`;
        this._popup.style.fontSize = `clamp(0.5rem, ${virtualFontSizePreferred}, ${virtualFontSizeMax})`;
    }

    public static setContent(content: HTMLElement): void {
        this._popup.innerHTML = "";
        this._popup.appendChild(content);
    }

    public static show(): void {
        this._popup.style.display = "block";
        // For some reason both elements get clicked at the same time if you don't 
        // use a timeout
        setTimeout(() => {
            this._closePanel.style.display = "block";
        }, 100);
        // console.log("shown info popup");
    }

    public static hide(): void {
        this._popup.style.display = "none";
        this._closePanel.style.display = "none";
        // console.log("hidden info popup");

        document.dispatchEvent(this._popupCloseEvent);
    }

    public static getComputedStyle(): CSSStyleDeclaration {
        return window.getComputedStyle(this._popup);
    }
}
